import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#096080", // Replace '#yourColorHere' with your desired color
    },
    secondary: {
      main: "#F4A600",
    },
  },
  navbarHeight: 48,
  footerHeight: 72,
  tableauEmbedView: {
    minHeight: 501,
    minWidth: 900,
  },
});

export default theme;
